import { useContext } from "react";

import SignupPersonalizationStep from "@/components/signup/SignupPersonalizationStep";
import { PATH } from "@/configs/router/routerConfig";
import { ChatAIContext } from "@/contexts/ChatAIContext";
import { isSignupSetupRoute } from "@/lib/signup/setupRouting";
import { useRouter } from "next/router";

export default function OnboardingOverlay() {
  const router = useRouter();
  const { isOnboardingPending, showPersonalizationOverlay, setShowPersonalizationOverlay } = useContext(ChatAIContext);
  const isSetupRoute = isSignupSetupRoute(router.asPath || router.pathname);

  if (isSetupRoute || !showPersonalizationOverlay || !isOnboardingPending) {
    return null;
  }

  const handleDismiss = () => {
    sessionStorage.setItem("onboarding_overlay_dismissed", "true");
    setShowPersonalizationOverlay(false);
  };

  const handleComplete = async () => {
    try {
      const isAlreadyOnConfigPage = router.pathname.includes("/setting/tenants") || router.pathname.includes("/agents");

      if (!isAlreadyOnConfigPage && router.pathname !== PATH.HOME_PAGE) {
        await router.replace(PATH.HOME_PAGE);
      }
    } finally {
      setShowPersonalizationOverlay(false);
      if (typeof window !== "undefined") {
        router.reload();
      }
    }
  };

  return (
    <SignupPersonalizationStep
      mode="dialog"
      open={showPersonalizationOverlay && isOnboardingPending}
      onDismiss={handleDismiss}
      onComplete={handleComplete}
    />
  );
}
